export default "__VITE_ASSET__xDG26LCT__"